var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Acciones", {
        attrs: { estado: _vm.otroDocumento.estado },
        on: {
          download: _vm.download,
          refresh: _vm.refresh,
          deleteDocument: _vm.deleteDocument,
          preview: _vm.openPreview,
          print: _vm.printFile,
        },
      }),
      _vm._v(" "),
      _c("section", { staticClass: "section" }, [
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column" }, [
            _c(
              "div",
              { staticClass: "box" },
              [
                _c("h1", { staticClass: "title document-title is-4" }, [
                  _c("i", { staticClass: "fas fa-file" }),
                  _vm._v(
                    "  " +
                      _vm._s(
                        _vm.otroDocumento.nombre.length > 50
                          ? _vm.otroDocumento.nombre.substring(0, 50) + "..."
                          : _vm.otroDocumento.nombre
                      )
                  ),
                ]),
                _vm._v(" "),
                _c("Informacion"),
              ],
              1
            ),
            _vm._v(" "),
            !this.isAvailableStatus
              ? _c("div", { staticClass: "box" }, [_c("Status")], 1)
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column is-3" },
            [
              _vm.otroDocumento.preview_uri
                ? _c("div", { staticClass: "box" }, [
                    _c("figure", { staticClass: "image" }, [
                      _vm.otroDocumento.preview_uri
                        ? _c(
                            "a",
                            {
                              staticClass: "show-magnifier-cursor",
                              on: {
                                click: function ($event) {
                                  _vm.previewModalActive = true
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: _vm.otroDocumento.preview_uri,
                                  alt: "Previsualización",
                                },
                              }),
                            ]
                          )
                        : _c("img", {
                            attrs: {
                              src: "/statics/default-document.png",
                              alt: "Previsualización",
                            },
                          }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: { active: _vm.previewModalActive },
                  on: {
                    "update:active": function ($event) {
                      _vm.previewModalActive = $event
                    },
                  },
                },
                [
                  _c("figure", { staticClass: "image" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.otroDocumento.preview_uri,
                          target: "_blank",
                        },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.otroDocumento.preview_uri,
                            alt: "Previsualización",
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }